/* Speed Card V1 · lane SP (S2 — the slow first-open screens). EN + AR of what the IFRS statements screen says (and the Disclosure Checklist while it adds its rows) while the
   statements it shows are the last ones calculated and the current ones are calculated in the background. The
   "Updating… (figures as of …)" line itself is the dashboard's own (1610_sb_c.js, sbC.*), as on the Final Analytical Review.
   No standard paragraph is quoted. */
const I18N_SPEED1_STORED = {
  en: {
    speed1: {
      ifrsHint: "The statements shown are the last ones calculated. They update by themselves when the current figures are ready. Validation and the exports always use the current figures.",
      dcRowsMore: "Showing the first {a} of {b} rows — the others appear in a moment.",
    },
  },
  ar: {
    speed1: {
      ifrsHint: "القوائم المعروضة هي آخر قوائم محسوبة، وتتحدث تلقائيًا عند جاهزية الأرقام الحالية. يستخدم التحقق والتصدير الأرقام الحالية دائمًا.",
      dcRowsMore: "تُعرض أول {a} من {b} صفًا — وتظهر البقية خلال لحظات.",
    },
  },
};

export default I18N_SPEED1_STORED;
